import React from 'react';

export const Messaging = () => (
  <div />
);
